import React, { useContext } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';

import { Button } from 'semantic-ui-react';

import '../../css/reports/ReportHideRowsLauncherButton.less';

import { SatCoreRegister } from '../../SatCoreRegistry';

import { DIALOG_NAMES } from '../../managers/DialogManager';

import ReportIdentityService from '../../services/reports/ReportIdentityService';

const ReportHideRowsLauncherButton = observer((props) => {
  const {
    shouldExpandAllRowsOnInit = true,
    t
  } = props;

  const {
    dialogManager
  } = useContext(MobXProviderContext);

  const handleLaunchReportHideRowsModal = () => {
    dialogManager.setOpenDialog(DIALOG_NAMES.REPORT_HIDE_ROWS_MODAL, {
      onClose: () => {
        dialogManager.closeDialog(DIALOG_NAMES.REPORT_HIDE_ROWS_MODAL);
      },
      onOpen: () => {
        // placeholder
      },
      shouldExpandAllRowsOnInit
    }/* , () => {} */);
    // }, 100);
  };

  const renderReportHideRowsLauncherButton = () => {
    const isReportStandardsClassroomDetailStudents = ReportIdentityService.isReportStandardsClassroomDetailStudents();
    const allowReportHideRowsLauncherButton = (
      !isReportStandardsClassroomDetailStudents
    );

    return allowReportHideRowsLauncherButton ? (
      <div className='ReportHideRowsLauncherButton'>
        <div className='report-hide-rows-btn-wrapper'>
          <Button onClick={() => handleLaunchReportHideRowsModal()}>
            {t('hideRows')}
          </Button>
        </div>
      </div>
    ) : null;
  };

  return renderReportHideRowsLauncherButton();
});
export default ReportHideRowsLauncherButton;

SatCoreRegister('ReportHideRowsLauncherButton', ReportHideRowsLauncherButton);
